import { SVG } from "../../../../../constants/assetLists";

interface SwitcherProps {
  active: string;
  onChange: (id: string) => void;
}

const options = [
  {
    id: "template",
    label: "לפי תבנית",
    inactiveClass: "rounded-l-[8px] rounded-r-[20px]",
  },
  {
    id: "manual",
    label: "הגדרה ידנית",
    inactiveClass: "rounded-l-[20px] rounded-r-[8px]",
  },
];

const Switcher = ({ active, onChange }: SwitcherProps) => {
  return (
    <div className="flex items-center justify-center font-sans">
      <div className="flex items-center gap-[3px]">
        {options.map(({ id, label, inactiveClass }) => {
          const isActive = active === id;

          return (
            <button
              key={id}
              onClick={() => onChange(id)}
              className={`
                relative flex items-center justify-center gap-2
                min-w-[200px] px-8 py-[7px]
                transition-colors
                ${
                  isActive
                    ? "bg-darkBlue text-white rounded-full z-10"
                    : `bg-gray80 text-darkBlue ${inactiveClass}`
                }
              `}
            >
              <span className="text-[17px] tracking-wide relative top-[1px]">
                {label}
              </span>

              {isActive && (
                <img
                  src={SVG.tickWhiteIcon}
                  alt=""
                  className="w-[16px] h-[16px]"
                />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Switcher;
